let showAlertFn = null;

export const setAlertFunction = (fn) => {
    showAlertFn = fn;
};

export const showGlobalAlert = (message, severity = 'error') => {
    if (showAlertFn) showAlertFn(message, severity);
};
